export default __webpack_public_path__ + "static/media/play.4ccb3a20.svg";